/**
 * Draggable in-page overlay used to visualise the virtualized-rows-render
 * timer. Created
 * lazily and only when the user has flipped on the "Skeleton render overlay"
 * toggle in the devtools Performance panel.
 */

import { makeMovableResizable } from './overlay-window.ts';

const OVERLAY_ID = 'chunk-render-debug';
const CONTENT_ID = 'chunk-render-debug-content';

function createOverlay(): HTMLElement {
  const overlay = document.createElement('div');
  overlay.id = OVERLAY_ID;
  Object.assign(overlay.style, {
    position: 'fixed',
    top: '10px',
    right: '10px',
    zIndex: '99999',
    background: 'rgba(0,0,0,0.85)',
    color: '#0f0',
    padding: '12px 16px',
    borderRadius: '8px',
    fontFamily: 'monospace',
    fontSize: '14px',
    maxWidth: '400px',
    whiteSpace: 'pre-wrap',
    pointerEvents: 'auto'
  });

  const content = document.createElement('div');
  content.id = CONTENT_ID;
  overlay.appendChild(content);
  document.body.appendChild(overlay);

  makeMovableResizable(overlay, {
    storageKey: 'databases-perf-tracing.skeleton-overlay-rect',
    resizable: false,
    title: 'SKELETON — drag'
  });

  return overlay;
}

export function setSkeletonOverlayText(text: string): void {
  const overlay = document.getElementById(OVERLAY_ID) ?? createOverlay();
  const content = overlay.querySelector<HTMLElement>(`#${CONTENT_ID}`) ?? overlay;
  content.textContent = text;
}

export function removeSkeletonOverlay(): void {
  document.getElementById(OVERLAY_ID)?.remove();
}
